import clearItemFromStorage from 'foundation/js/sessionStorageWrapper/clearItemFromStorage'
import getItemFromStorage from 'foundation/js/sessionStorageWrapper/getItemFromStorage'
import updateItemFromStorage from 'foundation/js/sessionStorageWrapper/updateItemFromStorage'
import { ref, onMounted, computed } from 'vue'
import { useStore } from 'vuex'

export default {
    name: 'SessionStorageFormularTest',
    setup() {
        const formularName = ref('testFormular')
        const firstName = ref(null)
        const lastName = ref(null)
        const email = ref(null)
        const phone = ref(null)
        const fighter = ref(null)
        const isFighter = ref(false)

        const teams = computed(() => {
            return store.state.forms.forms
        })

        const store = useStore()

        onMounted(() => {
            const formular = getItemFromStorage(formularName.value)
            if (formular) {
                addToVuex()
                firstName.value = formular.firstName
                lastName.value = formular.lastName
                email.value = formular.email
                phone.value = formular.phone
                fighter.value = formular.fighter
            }
        })

        const addToVuex = () => {
            store.dispatch('forms/setForm', {
                name: formularName.value,
                data: getItemFromStorage(formularName.value)
            })
        }

        const handleFighterCheck = (e) => {
            isFighter.value = e.target.checked
        }

        const submitFormular = () => {
            updateItemFromStorage(formularName.value, {
                firstName: firstName.value,
                lastName: lastName.value,
                email: email.value,
                phone: phone.value
            })
            addToVuex()
        }

        const submitFormular2 = () => {
            updateItemFromStorage(formularName.value, {
                fighter: isFighter.value
            })
            addToVuex()
        }

        const clearFormular = () => {
            clearItemFromStorage(formularName.value)
        }

        return {
            formularName,
            firstName,
            lastName,
            email,
            phone,
            fighter,
            teams,
            handleFighterCheck,
            submitFormular,
            submitFormular2,
            clearFormular
        }
    }
}
